import React from 'react';
import { css, useTheme } from '@emotion/react';
import type { AppTheme } from '@/theme/theme';
import { Button } from '@/components/ui/common/Button';

interface LanguageTabsProps {
  currentLanguage: string;
  onLanguageChange: (lang: string) => void;
  languages?: Array<{
    code: string;
    label: string;
  }>;
}

const defaultLanguages = [
  { code: 'ko', label: '한국어' },
  { code: 'en', label: 'English' },
  { code: 'es', label: 'Español' },
];

export const LanguageTabs: React.FC<LanguageTabsProps> = ({
  currentLanguage,
  onLanguageChange,
  languages = defaultLanguages,
}) => {
  const theme = useTheme() as AppTheme;
  const containerStyle = css`
    display: flex;
    gap: 0.5rem;
    align-items: center;
  `;

  const getButtonStyle = (isActive: boolean) => css`
    ${isActive &&
    `
      background-color: ${theme.colors.button.bg.primary.default} !important;
      color: ${theme.colors.button.text.primary} !important;
      border-color: ${theme.colors.button.bg.primary.default} !important;
      font-weight: ${theme.fontWeight.semibold};
    `}
  `;

  return (
    <div css={containerStyle}>
      {languages.map(lang => {
        const isActive = currentLanguage === lang.code;
        return (
          <Button
            key={lang.code}
            type="button"
            width="auto"
            variant="tertiary"
            onClick={() => onLanguageChange(lang.code)}
            css={getButtonStyle(isActive)}
          >
            {lang.label}
          </Button>
        );
      })}
    </div>
  );
};

